<template>

  <div>
    <div>
      
      <button 
        style="min-width: 230px !important"
        :disabled="loading || uploading"
        @click.prevent="triggerPhotoChange" 
        class="btn main-blue-bg">
        <span v-if="loading == false">
          <i class="fa fa-upload"></i>
        {{ label ? label : 'Seleccione foto'}}
        </span>
        <span v-else>Espere...</span>
      </button>

      <input
        accept="image/*"
        type="file"
        :id="inputId"
        class="hidden-file-inp"
        @change="managePhoto($event)"
      />

    </div>    
    <!-- Modal crop photo-->
    <div
    style="height: 70vh;"
      class="modal fade"
      :id="modalRef"
      tabindex="-1"
      role="dialog"
      :aria-labelledby="modalRef + '-label'"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="modalRef + '-label'">Corta la imagen</h5>
            <button type="button" class="close" @click="cancelPhotoCrop()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="max-width: 350px;">
              <img :id="modalRef+'-image'" :src="cropPreview" alt="Picture" style="max-width: 100%" />
            </div>
          </div>
          <div class="modal-footer">
            <div class="row" style="width:100%;margin-left:0;margin-right:0;">
              <div class="col-sm-6 text-left">
                <button
                  type="button"
                  :disabled="loading"
                  class="btn btn-secundary"
                  @click="cancelPhotoCrop()"
                >Cancelar</button>
              </div>
              <div class="col-sm-6 text-right">
                <button
                  type="button"
                  :disabled="loading"
                  class="btn main-bg"
                  @click="savePhotoCrop()"
                >Cortar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  </div>

</template>

<script>

export default {
  props: ['id', 'label', 'uploading'],
  data(){
    return {
      cropPreview: '',
      cropper: null,
      loading: false,
    }
  },
  methods: {
    triggerPhotoChange() {
      $(`#${this.inputId}`).trigger("click");
    },
    managePhoto(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.loading = true;
      this.cropPreview = URL.createObjectURL(files[0]);
      
      setTimeout(() => {
        this.initCropper();
        $(`#${this.modalRef}`).modal({
          backdrop: false,
          keyboard: false,
        });
        this.loading = false;
      }, 1000);
    },
    initCropper() {
      var image = document.querySelector(`#${this.modalRef}-image`);
      this.cropper = new Cropper(image, {
        viewMode: 3,
        data: {
          width: 250,
          height: 250,
        },
      });
    },
    savePhotoCrop() {
      this.cropper.getCroppedCanvas().toBlob((file) => {
        const outputPreview = URL.createObjectURL(file);
        this.photoPreview = outputPreview;
        this.$emit('file-selected', {
          file: file,
          preview: outputPreview
        });
        this.cancelPhotoCrop();
      });
    },
    cleanCrop() {
      if (this.cropper != null) {
        this.cropper.destroy();
        this.cropper = null;
      }
    },
    cancelPhotoCrop() {
      this.cleanCrop();
      $(`#${this.modalRef}`).modal("hide");
    },
  },
  computed: {
    modalRef(){
      return `crop-modal-${this.id}`;
    },
    inputId(){
      return `crop-input-${this.id}`;
    }
  }
}
</script>
<style scoped>
  button{
    min-width: 225px !important;
  }
</style>
